import React from "react";
import "./whatsappfloat.scss";
import { FaWhatsapp } from "react-icons/fa";
import { FiPhone } from "react-icons/fi";

const WhatsappFloat = () => {
	const phoneNumber = "9049928292"; // include country code (India = 91)
	
	const handleClick = () => {
		const url = `https://wa.me/${phoneNumber}`;
		window.open(url, "_blank");
	};
	
	return (
		<div className="whatsapp-container">
			
			<a className="phone-btn phonebottom" href={`tel:${phoneNumber}`}>
				<FiPhone />
			</a>
			
			{/* Bottom Button */}
			<div className="whatsapp-btn whatsappbottom" onClick={handleClick}>
				<FaWhatsapp />
			</div>
		</div>
	);
};

export default WhatsappFloat;